import { TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { centroCusto, centroCusto_v2 } from 'service/api'
import { useStore } from 'store'
import { mapRenderCentros } from 'templates/Cadastro/CentroCusto/mapArvore'
import Menu from '../MenuV2'
import { SelectProps } from './types'

interface IProps extends SelectProps {
    /** Não filtrar por empresa e sim por cliente */
    listAll?: boolean
}

export const SelectCentroCusto: React.FC<IProps> = ({
    size = 'small',
    variant = 'filled',
    width = 250,
    children,
    listAll = false,
}) => {
    const empresaId = useStore(state => state.companyId)
    const costCenterId = useStore(state => state.costCenterId)
    const setCostCenterId = useStore(state => state.setCostCenterId)

    const { data: filteredData = [], isFetched: isFilteredFetched } =
        centroCusto.useFetch({
            queryParams: { empresaId },
            enabled: !!empresaId && !listAll,
        })
    const { data: allData = [], isFetched: isAllFetched } =
        centroCusto_v2.useFetch({ enabled: listAll })

    const data = listAll ? allData : filteredData,
        isFetched = listAll ? isAllFetched : isFilteredFetched

    useEffect(() => {
        if (
            costCenterId > 0 &&
            isFetched &&
            !data.map(it => it.id).includes(costCenterId)
        )
            setCostCenterId(-1)
    }, [empresaId, isFetched])

    const naoFiltrar = 'Não filtrar'

    const nomeCentroCusto =
        data.find(it => it.id === costCenterId)?.nomeCentroCusto ?? undefined

    return (
        <TextField
            name="centroCustoId"
            label="Centro de custo"
            size={size}
            variant={variant}
            select
            fullWidth
            sx={{ width }}
            defaultValue={-1}
            SelectProps={{
                value: costCenterId,
                renderValue: () => nomeCentroCusto,
                MenuProps: {
                    PaperProps: {
                        sx: {
                            maxHeight: '50vh',
                            maxWidth: width,
                        },
                    },
                },
            }}
            InputLabelProps={{ shrink: !!nomeCentroCusto }}
        >
            {children}
            <Menu.Item value={-1} onClick={() => setCostCenterId(-1)}>
                {naoFiltrar}
            </Menu.Item>
            {mapRenderCentros(data).map(node => (
                <Menu.Item
                    key={node.id}
                    value={node.id}
                    onClick={() => setCostCenterId(node.id)}
                    sx={{ paddingLeft: 2 + node.space * 3 }}
                    title={node.nomeCentroCusto}
                    className="block truncate"
                >
                    {`${node.codigo} - ${node.nomeCentroCusto}`}
                </Menu.Item>
            ))}
        </TextField>
    )
}
